import { gql } from "@apollo/client"

import { IGQLApiError } from "../api.types"
import apolloClient, { normalizeApolloError } from "../apolloClient"
import {
    PaybisUpdateKybTcStatusData,
    PaybisUpdateKybTcStatusResponse,
} from "./paybisUpdateKybTcStatus.types"
import CommonApiError from "../errors/CommonApiError"
import parseHttpApiError from "../utils/parseHttpApiError"

const PAYBIS_UPDATE_KYB_TC_STATUS = gql`
    mutation PaybisUpdateKybTcStatus($companyId: String!, $tcStatus: String!) {
        paybisUpdateKybTcStatus(companyId: $companyId, tcStatus: $tcStatus) {
            companyId
            companyName
            createdAt
            email
            id
            notes
            status
            tcStatus
            updatedAt
            updatedBy
            updatedByName
        }
    }
`

export const paybisUpdateKybTcStatus = async (
    data: PaybisUpdateKybTcStatusData
): Promise<PaybisUpdateKybTcStatusResponse> => {
    const variables = {
        companyId: data.companyId,
        tcStatus: data.tcStatus,
    }

    try {
        const result = await apolloClient.mutate<
            PaybisUpdateKybTcStatusResponse["data"],
            typeof variables
        >({
            context: {
                headers: {
                    Authorization: `Bearer ${data.accessToken}`,
                },
            },
            fetchPolicy: "no-cache",
            mutation: PAYBIS_UPDATE_KYB_TC_STATUS,
            variables,
        })

        return { data: result.data! }
    } catch (err: unknown) {
        const error = normalizeApolloError(err)
        if (error instanceof CommonApiError) {
            throw parseHttpApiError(error.body as IGQLApiError[])
        }
        throw error
    }
}
